
import Vue from 'vue'

export default Vue.extend({
   name: 'FilterDropdown',
   props: {
      title: { type: String, default: '' },
      value: { type: [String, Number], default: null },
      initial: { type: [String, Number], default: null },
      size: { type: String, default: 'input-sm' },
      options: { type: Array as () => NameValuePair[], default: () => [] },
   },
   data() {
      return {
         innerValue: null as string | number | boolean | null,
      }
   },
   mounted() {
      if (this.value) {
         this.innerValue = this.value
      } else if (this.initial) {
         this.innerValue = this.initial
      }
   },
   methods: {
      onChange(event: any) {
         this.$emit('input', event.target.value)
         this.$emit('change', event.target.value)
      },
   },
   watch: {
      initial(newValue) {
         if (this.innerValue !== newValue) {
            this.innerValue = newValue
         }
      },
   },
})
